import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, pickerOption } from "@/mixins/index";
export default {
  name: "indexInterview",
  mixins: [loadMoreList, pickerOption],
  data: function data() {
    return {
      pagingReqFn: "useropDesc",
      pagingReqValue: "list",
      paramsData: {
        starttime: '',
        endtime: ''
      },
      pagingList: [{
        s0: '访问人次'
      }, {
        s0: '下载人次'
      }],
      value2: [],
      tabTab: [{
        label: '日期',
        Dvalue: 1
      }, {
        label: '日期',
        Dvalue: 1
      }],
      Dynamic: [],
      today: 0,
      yesterday: 0,
      totalinterview: 0
    };
  },
  mounted: function mounted() {
    this.value2 = this.$times.getStartEndTime();
    this.value2[0] = this.value2[0] * 1000 - 24 * 60 * 60 * 7000;
    this.value2[1] = this.value2[1] * 1000;
    this.paramsData.starttime = this.value2[0] / 1000;
    this.paramsData.endtime = this.value2[1] / 1000;
    this.getListNew();
  },
  activated: function activated() {},
  methods: {
    getListNew: function getListNew() {
      var _this = this;

      this.$api.useropDesc(this.paramsData).then(function (res) {
        if (res.code == 0) {
          // let d = {
          //   "2023-11-24": {
          //     "download": 1,
          //     "visit": 10,
          //   },
          //   "2023-11-25": {
          //     "download": 1,
          //     "visit": 3,
          //   },
          //   "2023-11-26": {
          //     "download": 2,
          //     "visit": 2,
          //   },
          //   "2023-11-27": {
          //     "download": 3,
          //     "visit": 1,
          //   },
          //   "2023-11-28": {
          //     "visit": 1
          //   }
          // }
          _this.pagingList = [{
            s0: '访问人次'
          }, {
            s0: '下载人次'
          }];

          var days = _this.$times.getDay();

          var today = _this.$times.timestampToTime(days.todayStartTime, 'YY-MM-DD');

          var yesterday = _this.$times.timestampToTime(days.yesterdayStartTime, 'YY-MM-DD');

          _this.Dynamic = [];
          _this.totalinterview = 0;
          _this.today = 0;
          _this.yesterday = 0;
          var i = 0;

          for (var key in res.data) {
            if (key == today) {
              _this.today = res.data[key].visit;
            }

            if (key == yesterday) {
              _this.yesterday = res.data[key].visit;
            }

            i++;

            _this.Dynamic.push({
              label: key,
              prop: 's' + i
            });

            _this.pagingList[0]['s' + i] = res.data[key].visit || 0;
            _this.pagingList[1]['s' + i] = res.data[key].download || 0;
            _this.totalinterview = _this.totalinterview += Number(_this.pagingList[0]['s' + i]);
          } // this.totalinterview = this.totalinterview + Number(this.pagingList[0].map((item) => { if (item != '访问人次') { return item } }))

        }
      });
    },
    timeChang: function timeChang(e) {
      this.paramsData.starttime = e[0] / 1000;
      this.paramsData.endtime = e[1] / 1000;
    }
  }
};